// extracted by mini-css-extract-plugin
export default {"title":"style_title__zE0SD","crossIcon":"style_crossIcon__W2Ydv","subTitle":"style_subTitle__FjulH","checkbox":"style_checkbox__Uq0-9","btnCustom":"style_btnCustom__4VtIZ"};